const normalizedSport = sport => String(sport || '')
  .trim()
  .toLowerCase()
  .replace(/^sport_/, '');

const normalizedDiscount = discount => Math.min(
  Math.max(Number(discount) || 0, 0),
  100
);

const affiliationAppliesToField = (affiliation, field) => {
  const fieldId = Number(field && field.id);
  if (!fieldId) return false;

  const affiliationFieldIds = (affiliation.fields || []).map(item => Number(item.id || item.fieldId));
  const fieldAffiliationIds = (field.affiliationsIds || []).map(Number);

  return affiliationFieldIds.includes(fieldId)
    || fieldAffiliationIds.includes(Number(affiliation.affiliationId));
};

const affiliationDiscountForSport = (affiliation, sport) => {
  if (affiliation.pricingMode !== 'dedicated_field_cost') {
    return normalizedDiscount(affiliation.discount);
  }

  const pricing = (affiliation.sportPricing || []).find(item => (
    normalizedSport(item.sport) === normalizedSport(sport)
  ));
  return normalizedDiscount(pricing && pricing.normalDiscount);
};

export const partnerBookingAffiliationDiscount = (affiliations, field) => (
  (affiliations || [])
    .filter(affiliation => affiliationAppliesToField(affiliation, field))
    .reduce((discount, affiliation) => Math.max(
      discount,
      affiliationDiscountForSport(affiliation, field && field.sport)
    ), 0)
);
